import { useMemo } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ContentCard } from '@olo-web/components/atoms/ContentCard';
import { useMerchantOrderTypeDetails } from '@domain/merchants/queries/useMerchantOrderTypeDetails';
import { useOrderType } from '@olo-web/utils/common/hooks';
import { EOrderTypes } from '@olo-web/types/enums';

export const OnPremisePayment = () => {
  const { data: orderTypeDetails } = useMerchantOrderTypeDetails();
  const orderType = useOrderType();

  const { payLaterCashEnabled, payLaterCCEnabled, onlineCCPaymentEnabled } = orderTypeDetails;

  const { paymentCardTitle, paymentCardDescription } = useMemo(() => {
    if (orderType === EOrderTypes.PICKUP) {
      return {
        paymentCardTitle: 'Payment required at pickup',
        paymentCardDescription: 'Payment is required when you pick up your order',
      };
    } else if (orderType === EOrderTypes.DELIVERY) {
      if (payLaterCashEnabled && payLaterCCEnabled && !onlineCCPaymentEnabled) {
        return {
          paymentCardTitle: 'Payment required upon delivery',
          paymentCardDescription: 'Cash or card payment is required upon delivery of your order.',
        };
      } else if (!payLaterCashEnabled && payLaterCCEnabled && !onlineCCPaymentEnabled) {
        return {
          paymentCardTitle: 'Payment required upon delivery',
          paymentCardDescription: 'Credit card payment is required upon delivery of your order.',
        };
      } else if (payLaterCashEnabled && !payLaterCCEnabled && !onlineCCPaymentEnabled) {
        return {
          paymentCardTitle: 'Cash payment required upon delivery',
          paymentCardDescription: 'Cash payment is required upon delivery of your order.',
        };
      }
    }
  }, [payLaterCashEnabled, payLaterCCEnabled, onlineCCPaymentEnabled, orderType]);
  return (
    <ContentCard title={paymentCardTitle}>
      <Flex justifyContent="flex-start" alignItems="flex-start" w="100%" mt={0}>
        <Text>{paymentCardDescription}</Text>
      </Flex>
    </ContentCard>
  );
};
